/*
 * @Author: 317473294@qq.com
 * @Date: 2023-09-04 21:20:05
 * @LastEditTime: 2023-09-07 23:14:18
 * @LastEditors: 317473294@qq.com
 * @Description: 
 * @FilePath: /english_admin_v1.1.0/src/api/knowledge.js
 */
import Axios from "../axios"

//创建目录
export function createKnowledge(data){
    return Axios({
        method:"post",
        url:"/api/createKnowledge",
        data:data
    })
}
//获取目录
export function getAllKnowledge(){
    return Axios({
        method:"get",
        url:"/api/knowledgeList",
        
    })
}
//更新课程目录
export function KnowledgeUpdata(data){
    return Axios({
        method:"patch",
        url:"/api/KnowledgeUpdata",
        data:data
    })
}
//删除课程目录
export function deleteKnowledge(data){
    return Axios({
        method:"delete",
        url:"/api/deleteKnowledge",
        data:data
    })
}
//根据courseid读取课程
export function getCourseidAll(data){
    return Axios({
        method:"post",
        url:"/api/getCourseidAll",
        data:data
    })
}

//模糊查询，通过搜索coursename
export function vogueFind(data){
    return Axios({
        method:"post",
        url:"/api/vogueFind",
        data:data
    })
}


// WEBPACK FOOTER //
// ./src/api/knowledge.js